import { mutationOptions } from '@tanstack/react-query';
import { gorgiasSessionIdentityAPIClient } from '../gorgiasSessionIdentityAPIClient';
import { GORGIAS_SESSION_IDENTITY_QUERY_KEYS } from './keys';
import type {
  CreateGorgiasAuthenticatedSessionIdentityResponse,
  CreateGorgiasGuestEmailChallengeRequest,
  CreateGorgiasGuestEmailChallengeResponse,
  VerifyGorgiasGuestEmailChallengeRequest,
  VerifyGorgiasGuestEmailChallengeResponse,
} from './types';

export const GORGIAS_SESSION_IDENTITY_QUERIES = {
  createGuestEmailChallenge: () =>
    mutationOptions<CreateGorgiasGuestEmailChallengeResponse, unknown, CreateGorgiasGuestEmailChallengeRequest>({
      mutationKey: GORGIAS_SESSION_IDENTITY_QUERY_KEYS.createGuestEmailChallenge(),
      mutationFn: (payload) => gorgiasSessionIdentityAPIClient.createGuestEmailChallenge(payload),
    }),
  verifyGuestEmailChallenge: () =>
    mutationOptions<VerifyGorgiasGuestEmailChallengeResponse, unknown, VerifyGorgiasGuestEmailChallengeRequest>({
      mutationKey: GORGIAS_SESSION_IDENTITY_QUERY_KEYS.verifyGuestEmailChallenge(),
      mutationFn: (payload) => gorgiasSessionIdentityAPIClient.verifyGuestEmailChallenge(payload),
    }),
  createAuthenticatedSessionIdentity: () =>
    mutationOptions<CreateGorgiasAuthenticatedSessionIdentityResponse, unknown, void>({
      mutationKey: GORGIAS_SESSION_IDENTITY_QUERY_KEYS.createAuthenticatedSessionIdentity(),
      mutationFn: () => gorgiasSessionIdentityAPIClient.createAuthenticatedSessionIdentity(),
    }),
};
